// extracted by mini-css-extract-plugin
export default {"blink":"Title_blink__mwaBk"};